<script setup>
import { computed } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import AppMenu from './AppMenu.vue';
import AppMenuProfile from './AppMenuProfile.vue';
import { TenantService } from '@/config/tenant';


// Tenant bilgisini computed olarak alalım
const currentTenant = computed(() => {
    const tenant = TenantService.getCurrentTenantName();
    // İlk harfi büyük yapalım
    return {
        fullName: tenant.charAt(0).toUpperCase() + tenant.slice(1),
        firstLetter: tenant.charAt(0).toUpperCase()
    };
});
const { layoutConfig, layoutState, onSidebarToggle, onAnchorToggle } = useLayout();

let timeout = null;

function onMouseEnter() {
    if (!layoutState.anchored) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        onSidebarToggle(true);
    }
}

function onMouseLeave() {
    if (!layoutState.anchored) {
        if (!timeout) {
            timeout = setTimeout(() => onSidebarToggle(false), 300);
        }
    }
}
</script>


<template>
    <div class="layout-sidebar" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div class="layout-sidebar-top">
            <a href="/">
                <svg width="167" height="49" viewBox="0 0 167 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="layout-sidebar-logo">
                    <defs id="defs2" />
                    <text xml:space="preserve" style="font-size: 22.3168px; fill: #000000; stroke-width: 1.85973"
                        x="62.797375" y="23.979361" id="text2" transform="scale(0.83571163,1.196585)">
                        <tspan id="tspan2" x="62.797375" y="23.979361" style="fill: #ffffff; stroke-width: 1.85973"> {{
                            currentTenant.fullName }}
                        </tspan>
                    </text>
                    <text xml:space="preserve" style="font-size: 47.9715px; fill: #000000; stroke-width: 3.99763"
                        x="4.3707757" y="38.105625" id="text3" transform="scale(1.0623966,0.94126808)">
                        <tspan id="tspan3" x="4.3707757" y="38.105625" style="fill: #ffffff; stroke-width: 3.99763"> {{
                            currentTenant.firstLetter }}
                        </tspan>
                    </text>
                </svg>
                <svg width="41" height="49" viewBox="0 0 41 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="layout-sidebar-logo-slim">
                    <text xml:space="preserve" style="font-size: 47.9715px; fill: #000000; stroke-width: 3.99763"
                        x="4.3707757" y="38.105625" id="text3" transform="scale(1.0623966,0.94126808)">
                        <tspan id="tspan3" x="4.3707757" y="38.105625" style="fill: #ffffff; stroke-width: 3.99763"> {{
                            currentTenant.firstLetter }}
                        </tspan>
                    </text>
                </svg>
            </a>
            <button class="layout-sidebar-anchor" type="button" @click="onAnchorToggle"></button>
        </div>
        <app-menu-profile v-if="layoutConfig.menuProfilePosition === 'start'"></app-menu-profile>
        <div class="layout-menu-container">
            <AppMenu />
        </div>
        <app-menu-profile v-if="layoutConfig.menuProfilePosition === 'end'"></app-menu-profile>
    </div>
</template>

<style lang="scss" scoped></style>
